var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column align-center text-center text-h6 pa-4 grey--text text-darken-1"},[_c('div',[_vm._v(" Faça login para adicionar o produto ao carrinho ")]),_c('v-btn',{staticClass:"mt-4",attrs:{"color":"primary"},on:{"click":_vm.handleShowLogin}},[_vm._v(" Fazer login ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }